// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__6ndZr","title":"Images45_title__B4WLV","images":"Images45_images__uhcCW"};